(() => {
  document.querySelectorAll('[data-local-reviews]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const grid = root.querySelector('[data-review-grid]');
    const cards = [...grid.querySelectorAll('[data-imported-review]')];
    const dialog = root.querySelector('[data-review-dialog]');
    const detail = dialog.querySelector('[data-review-detail]');
    const close = dialog.querySelector('[data-review-close]');
    let opener;
    let previousWidth = 0;
    function layout() {
      root.classList.remove('renly-local-reviews--masonry');
      grid.style.height = '';
      cards.forEach(card => { card.style.width = ''; card.style.transform = ''; });
      cards.forEach(card => {
        const body = card.querySelector('.renly-imported-review__body');
        card.querySelector('[data-review-more]').hidden = !card.hasAttribute('data-long-review') || body.scrollHeight <= body.clientHeight + 1;
      });
      if (matchMedia('(max-width: 699px)').matches) return;
      const gap = 24;
      const width = (grid.clientWidth - gap * 2) / 3;
      const heights = [0, 0, 0];
      root.classList.add('renly-local-reviews--masonry');
      cards.forEach(card => {
        card.style.width = `${width}px`;
        const column = heights.indexOf(Math.min(...heights));
        card.style.transform = `translate(${column * (width + gap)}px, ${heights[column]}px)`;
        heights[column] += card.offsetHeight + gap;
      });
      grid.style.height = `${Math.max(...heights) - gap}px`;
    }
    function dismiss() { dialog.close(); }
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-review-more], [data-review-photo], [data-imported-review]');
      if (!button || dialog.contains(button)) return;
      opener = button;
      detail.replaceChildren();
      const card = button.closest('[data-imported-review]');
      const photo = button.hasAttribute('data-review-photo');
      dialog.classList.toggle('renly-review-dialog--photo', photo);
      if (photo) {
        const original = card.querySelector('img');
        const image = document.createElement('img');
        image.src = original.dataset.reviewFullImage;
        image.alt = original.alt;
        detail.append(image);
      } else {
        const copy = card.cloneNode(true);
        copy.querySelector('[data-review-more]').remove();
        copy.querySelector('[data-review-photo]')?.remove();
        copy.removeAttribute('data-imported-review');
        detail.append(copy);
      }
      dialog.showModal();
      document.documentElement.classList.add('renly-review-dialog-open');
      close.focus();
    });
    cards.forEach(card => {
      card.tabIndex = 0;
      card.setAttribute('aria-haspopup', 'dialog');
      card.addEventListener('keydown', event => {
        if (event.target !== card || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        card.click();
      });
    });
    close.addEventListener('click', dismiss);
    dialog.addEventListener('click', event => { if (event.target === dialog) dismiss(); });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('renly-review-dialog-open');
      opener?.focus();
    });
    const observer = new ResizeObserver(() => {
      if (grid.clientWidth === previousWidth) return;
      previousWidth = grid.clientWidth;
      requestAnimationFrame(layout);
    });
    observer.observe(grid);
    document.fonts.ready.then(layout);
    layout();
  });
})();
